import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Reveal, Overline } from "@/components/public/Reveal";
import CallbackForm from "@/components/public/CallbackForm";
import Seo, { localBusinessLd } from "@/components/Seo";

export default function Contact() {
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <Seo title="Contact & devis gratuit" path="/contact" description="Contactez Acanthe Jardins pour votre devis gratuit d'aménagement extérieur. Paysagiste à Saint-Victoret (13730), intervention dans les Bouches-du-Rhône, le Var et le Vaucluse." jsonLd={localBusinessLd()} />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-14">
          <Overline>Contact</Overline>
          <h1 className="mt-4 font-display text-5xl lg:text-6xl text-forest leading-tight">Demandez votre devis gratuit</h1>
          <p className="mt-6 text-lg text-stone leading-relaxed">Collectivité, entreprise ou particulier : parlez-nous de votre projet, un expert vous recontacte sous 24h.</p>
        </Reveal>

        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12">
          <Reveal>
            <div className="space-y-4">
              {[
                { icon: MapPin, t: "Adresse", v: "665 Avenue du Raumartin, 13730 Saint-Victoret" },
                { icon: Phone, t: "Téléphone", v: "04 42 69 02 13", href: "tel:0442690213" },
                { icon: Phone, t: "Mobile", v: "06 34 58 63 33", href: "tel:0634586333" },
                { icon: Mail, t: "Email", v: "contact@acanthejardins.fr", href: "mailto:contact@acanthejardins.fr" },
                { icon: Clock, t: "Zones d'intervention", v: "Bouches-du-Rhône · Var · Vaucluse" },
              ].map((c) => (
                <div key={c.t} className="flex gap-4 rounded-2xl bg-white border border-border p-6">
                  <div className="h-11 w-11 rounded-xl bg-brand/10 flex items-center justify-center shrink-0"><c.icon className="text-brand" size={22} /></div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-stone">{c.t}</p>
                    {c.href ? <a href={c.href} className="text-forest font-medium hover:text-brand">{c.v}</a> : <p className="text-forest font-medium">{c.v}</p>}
                  </div>
                </div>
              ))}
              <div className="rounded-2xl overflow-hidden border border-border">
                <iframe title="carte" width="100%" height="240" style={{ border: 0 }} loading="lazy"
                  src="https://www.google.com/maps?q=665+Avenue+du+Raumartin,+13730+Saint-Victoret&output=embed" />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="rounded-2xl bg-white border border-border p-8 shadow-sm">
              <h2 className="font-display text-3xl text-forest mb-1">Formulaire de rappel</h2>
              <p className="text-sm text-stone mb-6">Tous les champs marqués * sont obligatoires</p>
              <CallbackForm />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
